import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { LoginProcessorFactory } from '../../../../core/processorfactory/loginprocessorfactory';
import { SendOTPDto } from 'src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto';
import { SubscriberValidationDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/subscribervalidation/subscribervalidationdto';
import { SubscriberValidationResponse } from 'src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationresponse';
import { SubscriberValidationRequestImpl } from 'src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationrequest';
import { SendOTPResponse } from 'src/com/sixdee/crbtportal/core/api/otp/sendotp/sendotpresponse';
import { SendOTPRequestImpl } from 'src/com/sixdee/crbtportal/core/api/otp/sendotp/sendotprequest';

export interface ForgotPasswordOTPAPIModel extends APIModel
{
    validateNumber(forgotPasswordOTPDto: SendOTPDto): void;
}

export class ForgotPasswordOTPAPIModelImpl extends APIModelImpl implements ForgotPasswordOTPAPIModel
{
    private loginProcessorFactory: LoginProcessorFactory;
    
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);

        this.loginProcessorFactory = this.getAPIProcesssorFactory().getLoginAPIProcessorFactory();
    }

    validateNumber(forgotPasswordGenerateOTPDto: SendOTPDto): void {
        let subscriberValidationDto = new SubscriberValidationDtoImpl();
        subscriberValidationDto.setMsisdn(forgotPasswordGenerateOTPDto.getMsisdn());
        subscriberValidationDto.setLanguage(this.getContext().getUserContext().getLanguage());

        this.loginProcessorFactory.validateSubscriber()
            .success(() => {
                this.resendOtpFunc(forgotPasswordGenerateOTPDto);
            })
            .failure((subscriberValidationResponse: SubscriberValidationResponse) => {
                this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                    subscriberValidationResponse.getDescription(), subscriberValidationResponse);
            })
            .execute(new SubscriberValidationRequestImpl(subscriberValidationDto));
    }

    private resendOtpFunc(createAccountSendOtpDto: SendOTPDto): void 
    {
        this.loginProcessorFactory.sendOTP()
                .success((generateOTPResponse : SendOTPResponse)=>
                {
                    this.getAPIModelHandler().onSuccess(generateOTPResponse.getAPIFeature(), 
                    generateOTPResponse.getDescription(), generateOTPResponse.getSendOTPDto());
                })
                .failure((generateOTPResponse : SendOTPResponse)=>
                {
                    this.getAPIModelHandler().onFailure(generateOTPResponse.getAPIFeature(), 
                         generateOTPResponse.getDescription(), generateOTPResponse.getSendOTPDto());

                }).execute(new SendOTPRequestImpl(createAccountSendOtpDto));
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/forgotpasswordotp/forgotpasswordotpapimodel.tsx